// ------------------------------------
// Imports
// ------------------------------------
import {
  CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_START,
  CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_END,
  SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_ERROR,
  CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_START,
  CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_END,
  SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_ERROR,
  CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_START,
  CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_END,
  SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_ERROR,
  CURRENT_ACTIVE_SECTION,
  ACTIVATION_CODE,
  ACTIVATION_CODE_CURRENCY
} from 'redux/actions/subscriptionActivate';
// ------------------------------------
// Reducer Handlers
// ------------------------------------

const accountDetails = {
  isProcessingAuth: false,
  info: {},
  error: null
};

const payment = {
  isError: false,
  isFetching: false,
  info: null
};

const addressDetails = {
  isError: false,
  isFetching: false,
  info: null
};

const initialState = {
  currentActive: 'activation-code',
  activationCode: '',
  activationCodeCurrency: 'USD',
  payment: { ...payment },
  addressDetails: { ...addressDetails },
  accountDetails: { ...accountDetails }
};

const REDUCER_HANDLERS = {
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_START]: state => ({
    ...state,
    payment: {
      ...state.payment,
      isFetching: true,
      isError: false
    }
  }),
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_END]: (state, action) => ({
    ...state,
    payment: {
      ...state.payment,
      info: action.payload,
      isFetching: false
    }
  }),
  [SUBSCRIPTION_ACTIVATE_PAYMENT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    payment: {
      errorMessage: action.payload,
      isError: true,
      isFetching: false
    }
  }),
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_START]: state => ({
    ...state,
    addressDetails: {
      ...state.addressDetails,
      isFetching: true,
      isError: false
    }
  }),
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_END]: (state, action) => ({
    ...state,
    addressDetails: {
      ...state.addressDetails,
      info: action.payload,
      isFetching: false
    }
  }),
  [SUBSCRIPTION_ACTIVATE_ADDRESS_DETAILS_ERROR]: (state, action) => ({
    ...state,
    addressDetails: {
      errorMessage: action.payload,
      isError: true,
      isFetching: false
    }
  }),
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_START]: (state, action) => {
    const isProcessingAuth = !action.payload.social;
    return {
      ...state,
      accountDetails: {
        ...state.accountDetails,
        isProcessingAuth: isProcessingAuth,
        isError: false
      }
    }
  },
  [CHECKOUT_SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_END]: (state, action) => ({
    ...state,
    accountDetails: {
      ...state.accountDetails,
      info: action.payload,
      isProcessingAuth: false
    }
  }),
  [SUBSCRIPTION_ACTIVATE_ACCOUNT_DETAILS_ERROR]: (state, action) => ({
    ...state,
    accountDetails: {
      errorMessage: action.payload,
      isError: true,
      isProcessingAuth: false
    }
  }),
  [ACTIVATION_CODE]: (state, action) => ({
    ...state,
    activationCode: action.payload
  }),
  [ACTIVATION_CODE_CURRENCY]: (state, action) => ({
    ...state,
    activationCodeCurrency: action.payload
  }),
  [CURRENT_ACTIVE_SECTION]: (state, action) => ({
    ...state,
    currentActive: action.payload
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function subscriptionActivate(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/subscriptionActivate.js